module.exports = "https://la-static.vkplay.ru/promo/newstart/img/demonic.fd3b7128.png";